import { Box, Divider, Typography, Button, useTheme, IconButton, CircularProgress } from "@mui/material"
import { useTaskContext } from "../../../../shared/context/taskContext"
import DropPhoto from "../../../../shared/components/DropPhoto"
import SaveIcon from '@mui/icons-material/Save';
import { useState } from "react"
import DeleteIcon from '@mui/icons-material/Delete';
import { useOt } from "../../../../shared/context/otContext"

export default function AttachReview() {
    const { taskByHash, saveTaskAttach, loadingSaveTaskAttach, deleteTaskAttach, loadingDeleteTaskAttach } = useTaskContext()
    const { ot } = useOt()
    const theme = useTheme()
    const [taskAttachBefore, setTaskAttachBefore] = useState({
        file: null,
        type_attach: "before_attach",
    })

    const [taskAttachAfter, setTaskAttachAfter] = useState({
        file: null,
        type_attach: "after_attach",
    })

    const [typeAttach, setTypeAttach] = useState(null)


    const handleSaveTaskAttach = (data) => {
        setTypeAttach(data.type_attach)
        saveTaskAttach(data)
    }

    const renderImage = (attach) => {
        return (
            <>
                <Box
                    sx={{
                        width: '100%',
                        border: `2px dashed ${theme.palette.divider}`,
                        borderRadius: '8px',
                        padding: 0.5,
                        textAlign: 'center',
                        backgroundColor: 'transparent',
                        transition: 'all 0.2s ease',
                        position: 'relative',
                        minHeight: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                  { ot.status.name === "in_process" && <IconButton
                        disabled={loadingDeleteTaskAttach}
                        sx={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            backgroundColor: "#000",
                            color: "#fff",
                            width: 40,
                            height: 40,
                            '&:hover': {
                                backgroundColor: "#000",
                            },
                            zIndex: 1000
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteTaskAttach(attach.id)
                        }}
                    >
                        <DeleteIcon fontSize="20" />
                    </IconButton>}
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                        gap: 2,
                        width: '100%',
                        p: 0.5
                    }}>
                        <Box
                            sx={{
                                position: 'relative',
                                aspectRatio: '1',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                border: `1px solid ${theme.palette.divider}`,
                            }}
                        >
                            <img src={attach.attach_url} alt="attach" style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                loading: 'lazy'
                            }} />
                        </Box>
                    </Box>
                </Box>
            </>
        )
    }
    return (
        <Box sx={{ p: 2, maxHeight: '800px', overflowY: 'auto' }}>
            <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 'bold' }}>Agregar fotos de la tarea</Typography>
            <Typography variant="body1" sx={{ fontSize: '12px' }}>
                Recuerda que las fotos deben ser en formato JPG, PNG o JPEG. y no son obligatorias.
            </Typography>
            <Divider sx={{ my: 2 }} />
            {ot.status.name === "in_process" && <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 'bold' }}>Antes de la tarea:</Typography>

                {!taskByHash.attaches.before_attach && <Button disabled={!taskAttachBefore.file || taskAttachBefore.file.length === 0 || (loadingSaveTaskAttach && typeAttach === 'before_attach')} variant="contained" color="primary"
                    startIcon={<SaveIcon />} onClick={() => handleSaveTaskAttach(taskAttachBefore)}> {loadingSaveTaskAttach && typeAttach === 'before_attach' ? <CircularProgress size={20} /> : "Guardar"}
                </Button>}
           
            </Box>}

            <Box sx={{ mt: 2 }}>
                {taskByHash.attaches.before_attach ?
                    renderImage(taskByHash.attaches.before_attach)

                    :
                    ot.status.name === "in_process" && <DropPhoto onChange={(file) => setTaskAttachBefore({ ...taskAttachBefore, file })} />}
            </Box>

           { ot.status.name === "in_process" && <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                    <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 'bold' }}>Después de la tarea:</Typography>
                    {!taskByHash.attaches.after_attach && <Button disabled={!taskAttachAfter.file || taskAttachAfter.file.length === 0 || (loadingSaveTaskAttach && typeAttach === 'after_attach')} variant="contained" color="primary" startIcon={<SaveIcon />}
                        onClick={() => handleSaveTaskAttach(taskAttachAfter)}> {loadingSaveTaskAttach && typeAttach === 'after_attach' ? <CircularProgress size={20} /> : "Guardar"}</Button>}
                </Box>}

            <Box sx={{ mt: 2 }}>
                {taskByHash.attaches.after_attach ? renderImage(taskByHash.attaches.after_attach) : ot.status.name === "in_process" && <DropPhoto onChange={(file) => setTaskAttachAfter({ ...taskAttachAfter, file })} />}
            </Box>

            {
                ot.status.name !== "in_process" && !taskByHash.attaches.before_attach && <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 'normal', alignItems: 'center', justifyContent: 'center', display: 'flex',
                        padding: '10px', borderRadius: '10px', border: `3px dotted ${theme.palette.divider}`
                     }}>
                        No se agregaron fotos antes de la tarea</Typography>
                </Box>
            }

            {
                ot.status.name !== "in_process" && !taskByHash.attaches.after_attach && <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 'normal', alignItems: 'center', justifyContent: 'center', display: 'flex',
                        padding: '10px', borderRadius: '10px', border: `3px dotted ${theme.palette.divider}`
                     }}>
                        No se agregaron fotos después de la tarea</Typography>
                </Box>
            }
        </Box>
    )
}